var global = require('../internals/global');

module.exports = global.Promise;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/core-js-pure/internals/native-promise-constructor.js
// module id = 1276
// module chunks = 1